import BaseModelInstance from './base.model'
import { AgentPackage as ModelDefinition } from './model-definitions'

class AgentPackage extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default AgentPackage
